import { IMovementScheduleComponent } from '@modeso/types__aumico-lib-annualreport-be';

export interface IMovementScheduleComponentDelegation {
    getMovementScheduleComponentData(componentData: IMovementScheduleComponent, componentIndex: number): void;
}
